import { initializeAuthenticatedFiles } from './Services/AuthenticatedFiles';
import "core-js/es/array/flat";
import "core-js/es/object/entries";
import "core-js/es/object/from-entries";
import "core-js/es/object/values";
import "moment/min/locales";
import ReactDOM from "react-dom/client";
import { installChunkReloadGuard } from "./Helper/chunkReloadGuard";
import CommunicationManager from "./Helper/CommunicationManager";
import { handleGleapLink } from "./Helper/handleGleapLink";
import HeightUpdateManager from "./Helper/HeightUpdateManager";
import KeyboardManager from "./Helper/KeyboardManager";
import "./index.scss";
import { AppMode, useRouterStore } from "./Stores/Router";
import App from "./Views/App/App";
import { isSalesDemoMode, openSalesDemoUrl } from "./salesDemo/protocol";

export { handleGleapLink } from "./Helper/handleGleapLink";

// Recover automatically when a stale iframe requests a build asset that a later
// deploy has purged (returned as text/html by the SPA fallback). See
// chunkReloadGuard.ts and ticket #136545.
installChunkReloadGuard();

// Mock mode: run the real <App/> standalone from mock data — no parent SDK
// frame, no config/API server, no websocket. See src/mock/mockBoot.ts. Kept out
// of the production bundle via the dynamic import() below (a separate chunk that
// is only ever requested when the flag is on).
// NOTE: no `typeof process !== "undefined"` guard here — CRA/webpack replaces
// the whole `process.env.REACT_APP_MOCK_MODE` member expression with a literal
// string at compile time (standard CRA env-var handling), but webpack 5 does NOT
// polyfill the bare `process` global in the browser bundle. A `typeof process`
// check would reference that (absent) global at runtime and always be false,
// silently defeating this whole branch regardless of the env var's value.
const isMockMode =
  process.env.REACT_APP_MOCK_MODE === "1" ||
  (typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("mock") === "1");

var communicationInitialized = false;
const initializeCommunication = () => {
  if (communicationInitialized) {
    return;
  }

  communicationInitialized = true;
  HeightUpdateManager.getInstance().start();
  KeyboardManager.getInstance().start();
  CommunicationManager.getInstance().sendMessage({
    name: "ping",
  });
};
if (!isSalesDemoMode()) initializeCommunication();

try {
  if (window.location.pathname.replace(/\/+$/, "") === "/chatbar") {
    useRouterStore.getState().setAppMode(AppMode.CHATBAR);
  }
} catch (e) {}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
if (isSalesDemoMode()) {
  Promise.all([import("./salesDemo/boot"), import("./salesDemo/SalesDemoApp")]).then(([boot, { default: SalesDemoApp }]) => {
    boot.startSalesDemo();
    root.render(<SalesDemoApp />);
  });
} else {
  initializeAuthenticatedFiles().finally(() => root.render(<App />));
}

if (isMockMode && !isSalesDemoMode()) {
  // The ping above harmlessly no-ops (there is no parent frame to reply), so no
  // session/config/widget-status-update ever arrives. Seed everything directly.
  import("./mock/mockBoot").then((m) => m.startMockMode());
}

document.onclick = function (e) {
  e = e || window.event;
  var element: any = e.target || e.srcElement;

  // Traverse up the DOM tree to find the <a> tag
  while (element && element.tagName !== "A" && element.parentNode) {
    element = element?.parentNode;
  }

  if (!element || element.tagName !== "A") {
    return;
  }

  if (
    element &&
    element.tagName === "A" &&
    element.href &&
    element.href.length > 0
  ) {
    if (isSalesDemoMode()) {
      e.preventDefault();
      openSalesDemoUrl(element.href);
      return false;
    }
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(element.href)) {
      return handleGleapLink(
        element.href,
        element.getAttribute("target") === "_blank",
      );
    }
  }
};
